<h2 mat-dialog-title class="dialog-header">
  {{'pendingevent.title'|traduccion}}
  <button mat-icon-button class="close-btn" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content pending-event-dialog-content mat-typography">
  <section class="pending-event-hero">
    <div>
      <div class="pending-event-kicker">{{'pendingevent.details.kicker'|traduccion}}</div>
      <h3>{{ valueOrDash(pendingEvent?.eventName) }}</h3>
      <p>{{ valueOrDash(pendingEvent?.entityType) }} · {{'pendingevent.details.uuid'|traduccion}} {{ valueOrDash(pendingEvent?.uuid) }}</p>
    </div>
    <div class="pending-event-hero-chips">
      <span [class]="statusClass(pendingEvent?.status)">{{ formatEnumLabel(pendingEvent?.status) }}</span>
      <span class="pe-chip pe-chip--neutral">{{'pendingevent.details.retryCount'|traduccion}} {{ valueOrDash(pendingEvent?.retryCount) }}</span>
    </div>
  </section>

  <div class="pending-event-grid">
    <mat-card class="pending-event-card">
      <h4>{{'pendingevent.details.aggregate.title'|traduccion}}</h4>
      <div class="pending-event-fields">
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.aggregate.eventAggregateType'|traduccion}}</span>
          <span>{{ valueOrDash(pendingEvent?.eventAggregateType) }}</span>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.aggregate.eventAggregateId'|traduccion}}</span>
          <code>{{ valueOrDash(pendingEvent?.eventAggregateId) }}</code>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.aggregate.tenantId'|traduccion}}</span>
          <span>{{ valueOrDash(pendingEvent?.tenantId) }}</span>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.aggregate.locationId'|traduccion}}</span>
          <span>{{ valueOrDash(pendingEvent?.locationId) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="pending-event-card">
      <h4>{{'pendingevent.details.versioning.title'|traduccion}}</h4>
      <div class="pending-event-fields">
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.versioning.eventDomainVersion'|traduccion}}</span>
          <span>{{ valueOrDash(pendingEvent?.eventDomainVersion) }}</span>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.versioning.domainVersion'|traduccion}}</span>
          <span>{{ valueOrDash(pendingEvent?.domainVersion) }}</span>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.versioning.createdAt'|traduccion}}</span>
          <span>{{ formatDateTime(pendingEvent?.createdAt) }}</span>
        </div>
        <div class="pending-event-field">
          <span class="pending-event-field-label">{{'pendingevent.details.versioning.updatedAt'|traduccion}}</span>
          <span>{{ formatDateTime(pendingEvent?.updatedAt) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="pending-event-card pending-event-card--wide">
      <h4>{{'pendingevent.details.traceability.title'|traduccion}}</h4>
      <div class="pending-event-list">
        <div class="pending-event-list-item">
          <span>{{'pendingevent.details.traceability.lastSentAt'|traduccion}}</span>
          <strong>{{ formatDateTime(pendingEvent?.lastSentAt) }}</strong>
        </div>
        <div class="pending-event-list-item">
          <span>{{'pendingevent.details.traceability.ackedAt'|traduccion}}</span>
          <strong>{{ formatDateTime(pendingEvent?.ackedAt) }}</strong>
        </div>
        <div class="pending-event-list-item">
          <span>{{'pendingevent.details.traceability.failedAt'|traduccion}}</span>
          <strong>{{ formatDateTime(pendingEvent?.failedAt) }}</strong>
        </div>
      </div>
    </mat-card>

    <mat-card class="pending-event-card pending-event-card--wide">
      <h4>{{'pendingevent.details.payload'|traduccion}}</h4>
      <pre class="pending-event-pre">{{ formatJson(pendingEvent?.payload) }}</pre>
    </mat-card>
  </div>
</mat-dialog-content>
